import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { GetProposals } from "../functions/GetProposals";
import { db } from "../utils/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
  getCountFromServer,
} from "firebase/firestore";
import { uuidv4 } from "@firebase/util";

export default function RecentProposals() {
  const { community } = useParams();
  const navigate = useNavigate();

  const [queryState, setQueryState] = useState({
    isLoading: true,
    errorMessage: "",
    docSnapshots: null,
  });

  useEffect(() => {
    async function getUserLevel() {
      const docRef = doc(db, "Users", localStorage.getItem("id"));
      const docSnap = await getDoc(docRef);

      if (docSnap.data().userTypeNumber < 3) {
        navigate(-1);
      }
    }

    getUserLevel();
    async function loader() {
      try {
        setQueryState({
          isLoading: true,
          errorMessage: "",
          docSnapshots: null,
        });
        const querySnapshot = query(
          collection(db, "Proposals"),
          where("slug", "==", community)
        );
        const docs = await getDocs(querySnapshot);
        var arr = [];
        for (let i = 0; i < docs.size; i++) {
          const ele = docs.docs[i].id;
          const element = docs.docs[i].data();
          const votesForQuery = query(
            collection(db, "Proposals", docs.docs[i].id, "Votes"),
            where("for", "==", true)
          );
          const votesFor = await (await getDocs(votesForQuery)).size;
          element.votesFor = votesFor;

          const votesAgainstQuery = query(
            collection(db, "Proposals", docs.docs[i].id, "Votes"),
            where("for", "==", false)
          );
          const votesAgainst = await (await getDocs(votesAgainstQuery)).size;
          element.votesAgainst = votesAgainst;

          element.id = ele;
          arr.push(element);
          setQueryState({
            isLoading: false,
            errorMessage: "",
            docSnapshots: arr,
          });
        }
      } catch (error) {
        setQueryState({
          isLoading: false,
          errorMessage: "Error",
          docSnapshots: null,
        });
        console.log(error);
      }
    }

    loader();
  }, []);

  const { isLoading, errorMessage, docSnapshots } = queryState;

  let content;

  if (isLoading) {
    content = (
      <div
        className="spinner-border text-primary"
        style={{ display: "flex", margin: "2em auto" }}
        role="status"
      >
        <span className="visually-hidden">Creating Community...</span>
      </div>
    );
  } else if (errorMessage) {
    content = errorMessage;
  } else {
    content = (
      <>
        <div className="dashboard_heading">
          {/* Remove inline styles  */}
          <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Title</b>
          <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Votes For</b>
          <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>
            Votes Against
          </b>
          <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Status</b>
          <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Community</b>
        </div>

        {queryState.docSnapshots.map((prop, i) => {
          console.log(prop);
          return (
            <Link
              key={uuidv4()}
              to={`/${community}/${prop.id}`}
              style={{ textDecoration: "none", color: "black" }}
            >
              <div key={i} className="dashboard_datarow">
                {/* Remove inline styles */}
                <p style={{ flex: 1, margin: "1em 0" }}>{prop.title}</p>
                <p style={{ flex: 1, margin: "1em 0" }}>{prop.votesFor}</p>
                <p style={{ flex: 1, margin: "1em 0" }}>{prop.votesAgainst}</p>
                <p style={{ flex: 1, margin: "1em 0" }}>{prop.status}</p>
                <p style={{ flex: 1, margin: "1em 0" }}>{prop.community}</p>
              </div>
            </Link>
          );
        })}
      </>
    );
  }

  return content;
}
